<!--CC: simplified mailbox list for onboarding wizard-->
<div class="flex-column gap-3 f-1-0" style="overflow: auto;">

	<!--CC: loading state-->
	<div class="flex-column align-items-center justify-content-center f-1-0" *ngIf="loadingInProcess">
		<loader></loader>
	</div>

	<!--CC: empty state-->
	<div class="flex-column align-items-center gap-2 py-4 text-muted" *ngIf="!loadingInProcess && !mailboxes?.length">
		<i class="far fa-mailbox" style="font-size: 32px;"></i>
		<span>No mailboxes found</span>
	</div>

	<!--CC: mailbox list-->
	<ng-container *ngIf="!loadingInProcess && mailboxes?.length">
		<span class="text-muted" style="font-size: 13px;">Select the mailboxes you want to protect.</span>

		<!--CC: search bar and selected count badge-->
		<div class="flex-row align-items-center gap-2">
			<input type="text" placeholder="Search mailboxes..."
				   style="width: 300px;"
				   [(ngModel)]="searchTerm"
				   (ngModelChange)="searchMailboxes()"/>
			<span class="badge text-primary border border-primary bg-white ms-auto" style="font-size: 12px;" *ngIf="selectedCount">
				{{selectedCount}} mailbox{{selectedCount > 1 ? 'es' : ''}} selected
			</span>
		</div>

		<!--CC: sortable table header with select all, styled like trustifi-table-->
		<div class="flex-row align-items-center gap-3 px-3 py-2" style="font-size: 0.85em; color: grey; text-transform: uppercase; border-bottom: 1px solid var(--bs-border-color);">
			<input type="checkbox" [(ngModel)]="selectAll" (ngModelChange)="toggleSelectAll()" style="width: 16px; height: 16px;"/>
			<div class="f-1-0 flex-row align-items-center cursor-pointer" (click)="sort('name')">
				<span style="transition: color 0.2s;" [ngClass]="{'text-primary': sortBy === 'name' || sortBy === '-name'}">Name</span>
				<a style="margin-top: 1px; padding-left: 5px;" tooltip="Sort">
					<i class="zmdi" style="width: 10px; transition: color 0.2s;"
					   [ngClass]="{'zmdi-chevron-up': sortBy === 'name', 'zmdi-chevron-down': sortBy !== 'name', 'text-primary': sortBy === 'name' || sortBy === '-name'}"></i>
				</a>
			</div>
			<div class="f-1-0 flex-row align-items-center cursor-pointer" (click)="sort('email')">
				<span style="transition: color 0.2s;" [ngClass]="{'text-primary': sortBy === 'email' || sortBy === '-email'}">Email</span>
				<a style="margin-top: 1px; padding-left: 5px;" tooltip="Sort">
					<i class="zmdi" style="width: 10px; transition: color 0.2s;"
					   [ngClass]="{'zmdi-chevron-up': sortBy === 'email', 'zmdi-chevron-down': sortBy !== 'email', 'text-primary': sortBy === 'email' || sortBy === '-email'}"></i>
				</a>
			</div>
			<div class="flex-row align-items-center cursor-pointer" style="width: 120px;" (click)="sort('license')">
				<span style="transition: color 0.2s;" [ngClass]="{'text-primary': sortBy === 'license' || sortBy === '-license'}">License</span>
				<a style="margin-top: 1px; padding-left: 5px;" tooltip="Sort">
					<i class="zmdi" style="width: 10px; transition: color 0.2s;"
					   [ngClass]="{'zmdi-chevron-up': sortBy === 'license', 'zmdi-chevron-down': sortBy !== 'license', 'text-primary': sortBy === 'license' || sortBy === '-license'}"></i>
				</a>
			</div>
		</div>

		<!--CC: mailbox rows-->
		<div class="flex-column">
			<ng-container *ngFor="let mailboxObj of mailboxes">
				<div class="flex-row align-items-center gap-3 px-3 py-2 hvr-darken-light cursor-pointer"
					 style="border-bottom: 1px solid var(--bs-border-color);"
					 *ngIf="!mailboxObj.hide"
					 (click)="toggleMailboxSelection(mailboxObj)">
					<input type="checkbox" [(ngModel)]="mailboxObj.selected" (click)="$event.stopPropagation()" (ngModelChange)="updateSelectedCount()" style="width: 16px; height: 16px;"/>
					<!--CC: name-->
					<span class="f-1-0 text-truncate">{{mailboxObj.name || '-'}}</span>
					<!--CC: email-->
					<span class="f-1-0 text-truncate">{{mailboxObj.email}}</span>
					<!--CC: license-->
					<span style="width: 120px;">{{mailboxObj.license || '-'}}</span>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>
